import { gql } from "@apollo/client";
import ReactTooltip from "react-tooltip";
import React, { useState, useEffect, useRef} from "react";
import { apolloClient } from "../../../index";
import dateFormat from "dateformat";
import DownloadIcon from "../../../assets/icons/download.svg";
import { notify } from "../../Notify/Notify";

const defaultColumns = [
  "File Name",
  "Status",
  "Added By",
  "Modified On",
  "Modified By",
  "Shared With",
];

const DownloadDropDown = (props) => {
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [downloadOpen, setDownloadOpen] = useState("none");
  const dropdownRef = useRef(null);

  const [selected, setSelected] = useState(props.selectedColumns)
  
  useEffect(() => {
    const openDropDown = (e) => {

      setSelectedColumns(
        props.selectedColumns
      );
      dropdownRef.current !== null &&
        e.target.id !== "downloadDropdown" &&
        !e.target.classList.contains("dropDown") &&
        (dropdownRef.current.style.display = "none");
      dropdownRef.current.style.display === "none"
        ? setDownloadOpen("none")
        : setDownloadOpen("block");
    };

    window.addEventListener("click", openDropDown);

    return () => {
      window.removeEventListener("click", openDropDown);
    };
  }, [props.selectedColumns]);

  const downloadHandler = (e) => {
    let selectColumns
    if(selected.length > 0){
      selectColumns = [...selected];
    }else{
      selectColumns = [...selectedColumns];
    }
    const checked = e.target.checked;
    const checkedValue = e.target.value;
    checked
      ? selectColumns.push(checkedValue)
      : (selectColumns = selectColumns.filter((item) => {
          return item !== checkedValue;
        }));
    setSelected(selectColumns)
  };

  const SelectedHandler = () => {
    const documents_arr = [];
    let downloadCol = selected.length > 0 ? selected : selectedColumns
   
    props.documentItems.map((document) => {      
      const newObj = {};      
      downloadCol.map((selectedColumn) => {
        selectedColumn === "addedBy"
          ? (newObj[
              "Added By"
            ] = `${document.createdBy.firstName} ${document.createdBy.lastName}`)
          : selectedColumn === "modifiedBy"
          ? (newObj[
              "Modified By"
            ] = `${document.modifiedBy.firstName} ${document.modifiedBy.lastName}`)
          : selectedColumn === "modifiedOn"
          ? (newObj["Modified On"] = dateFormat(
              document.modifiedTs,
              "mmm dd, yyyy"
            ))
          : selectedColumn === "status"
          ? (newObj["Status"] = document.status.name)
          : selectedColumn === "sharedWith"
          ? (newObj["Shared With"] = document["Shared With"])
          : selectedColumn === "files"
          ? (newObj["Files"] =
              document["File Name"])
          : selectedColumn === "Description"
          ? (newObj[selectedColumn] =
                  document["Description"])
          : selectedColumn === "Document Type"
          ? (newObj[selectedColumn] =
                          document["Document Type"])
          : (newObj[selectedColumn] = document[selectedColumn] || "");
        return true;
      });
      documents_arr.push(newObj);
      return true;
    });
    
    const documentDetails = {
      document_details: documents_arr,
    };
    const variables = {
      folderId: props.match.params.subId,
      abstractJson: JSON.stringify(documentDetails),
    };
    apolloClient
      .mutate({
        mutation: gql`
          mutation ExportToExcel($folderId: UUID!, $abstractJson: String!) {
            exportToExcel(folderId: $folderId, abstractJson: $abstractJson) {
              success
              fileBase64
              folder {
                title
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        let a = document.createElement("a");
        a.href = `data:application/xlsx;base64,${result.data.exportToExcel.fileBase64}`;
        a.download = result.data.exportToExcel.folder.title + ".csv";
        a.click();
        const title = "Success";
        const detail = "Download successful!";
        const type = "success";
        notify(title, detail, type);
      })
      .catch((e) => {
        const title = "Error";
        const detail = "Sorry could not download please download again! ";
        const type = "error";
        notify(title, detail, type);
      });
  };

  const openDrop = () => {
    let style = dropdownRef.current.style.display;
    dropdownRef.current.style.display =
      style === "none" || style === "" ? "block" : "none";
    style === "none" || style === ""
      ? setDownloadOpen("none")
      : setDownloadOpen("block");
  };

  return (
    <div className="button-group pr-3 download-drop-btn d-flex">
      <ReactTooltip id="columnsTip" place="top" effect="solid">
        Download
      </ReactTooltip>
      <div
        id="downloadDropdown"
        className={`list-action-button btn-tertiary download- btn-dropdown custom-btn ${
          downloadOpen === "block" ? "active" : ""
        }`}
        onClick={openDrop}
      >
        <div id="downloadDropdown" className="text-auto-primary">
          <img
            id="downloadDropdown"
            src={DownloadIcon}
            alt="DownloadIcon"
            width="20"
            height="20"
            // onClick={openDrop}
          />
        </div>
        <div
          id="downloadDropdown"
          className="text-auto-secondary"
          data-tip
          data-for="downloadTip"
        >
          <img
            id="downloadDropdown"
            src={DownloadIcon}
            alt="DownloadIcon"
            width="20"
            height="20"
            // onClick={openDrop}
          />
        </div>
      </div>
      <div className="dropdown-menu download-menu" ref={dropdownRef}>
        <div className="dropDown cd-header pt-4 pb-4">
          Include columns in excel
        </div>
        <ul
          className="dropDown pl-4 mb-2 overflow-auto"
          id="style-1"
          style={{ marginLeft: "-13px" }}
        >
          {[...defaultColumns, ...props.columns].map((key, index) => (
            <li key={index} className="dropDown d-flex pt-2 align-items-center">
              <div className="dropDown pr-2">
                <input
                  className="dropDown"
                  type="checkbox"
                  value={key}
                  id={key.toLowerCase().replace(" ", "")}
                  onChange={downloadHandler}
                  checked={
                    selected.includes(
                      key.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
                    ) || key === "File Name" || selected.includes(key) || selected.includes(key)
                  }
                />
              </div>
              <label
                style={{ whiteSpace: "break-spaces" }}
                id="dropDown"
                className="dropDown download-menu-text"
                htmlFor={key}
              >
                {key}
              </label>
            </li>
          ))}
        </ul>
        <div className="cd-footer pt-3 pb-3" onClick={SelectedHandler}>
          Download
        </div>
      </div>
    </div>
  );
};

export default DownloadDropDown;
